<template>
  <div class="md:w-1/2">
    <vx-input-group>
    <ValidationProvider :name="$t('Hora')" rules="required" v-slot="{ errors }">
        <vs-input style="  min-width: 100px;"
          :label="label"
          v-model="inputData"
          @input="handleInput"
          type="time"
          class="w-full"
          :disabled="disabled"
        />
        <p class="text-danger" style="text-align: center;">{{ errors[0] }}</p>
    </ValidationProvider>
    </vx-input-group>
  </div>
</template>
<script>
export default {
  name: 'TimeInput',
  props: {
    value: {
      type: String | undefined,
      required: true,
    },
    label: {
      type: String | undefined,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      inputData: this.value,
    };
  },
  methods: {
    handleInput () {
      this.$emit('input', this.inputData);
    },
  },
};
</script>
<style></style>
